import React, { useState, useRef } from "react";
import Slider from "react-slick";
import "./SlidingCardSection.css";

// Trainer data
const trainerData = [
  {
    name: "Rohan K Barithaya",
    title: "Founder & High Performance Director",
    image: require("../assets/Rohan.png"),
    description:
      "M.sc In Strength & Conditioning, Loughborough University, UK. Diploma in Sports Therapy, BSc In Exercise & Sports Science, Manipal University.",
  },
  {
    name: "Pallavi Poojary",
    title: "Lead Sports Physiotherapist",
    image: require("../assets/Pallavi.png"),
    description: "Bachelors in Physiotherapy, MCHP, Manipal University, Manipal.",
  },
  {
    name: "Varun Shetty",
    title: "Sports Scientist",
    image: require("../assets/Varun.png"),
    description: "B.sc In Exercise & Sports Science, Manipal University, Manipal.",
  },
    {
    name: "Swasthik",
    title: "Sports Scientist",
    image: require("../assets/swasthik.png"),
    description: "B.sc In Exercise & Sports Science, Manipal University, Manipal.",
  },
  {
    name: "Deeksha Anchan",
    title: "Sports Physiotherapist",
    image: require("../assets/Deeksha.png"),
    description: "Bachelors In Physiotherapy, RGUHS University, Mangalore.",
  },
   {
    name: "Sanjana Patil",
    title: "Sports Nutritionist",
    image: require("../assets/Sanjana.png"),
    description:
      "M.sc In Applied Nutrition & Dietetics, Manipal Acedemy of Higher Education, Manipal.",
  },
  {
    name: "Sneha Kotian",
    title: "Admin",
    image: require("../assets/Sneha.png"),
    description:
      "B.A. in Sociology, SNDT University, Mumbai.",
  },
  {
    name: "Pratham Naik",
    title: "Sr. Embedded System Engineer",
    image: require("../assets/Pratham.png"),
    description:
      "B.E. in Electronics & Communication, Sahyadri College of Engineering & Management, Mangalore.",
  },
  {
    name: "Karthik Pattar",
    title: "Jr. Embedded System Engineer",
    image: require("../assets/Karthik.png"),
    description:
      "B.E. in Electronics & Communication",
  },
  {
    name: "Chetan kumar",
    title: "Sr. Software Engineer",
    image: require("../assets/Ch.png"),
    description:
      "B.E. in Computer Science & Engineering.",
  },
  {
    name: "Anmol D Poojari",
    title: "Software Engineer",
    image: require("../assets/Anmol.png"),
    description:
      "B.E. in Computer Science & Engineering.",
  },
];

// Athlete data
const athleteData = [
  {
    name: "Nishchith Pai",
    // title: "Cricket, Winners: BCCI Kooch Behar Trophy; Runners U-19 India A Team: Challengers Trophy; Represented Hubli Tigers in Maharaja Trophy (KPL); ",
    image: require("../assets/athelete-1.png"),
    description: "Cricket, Winners: BCCI Kooch Behar Trophy; Runners U-19 India A Team: Challengers Trophy; Represented Hubli Tigers in Maharaja Trophy (KPL)",
  },
  {
    name: "Mark",
    // title: "Sprinter, Gold medal at 4x100m Relay at South Zone Junior Athletics Championship; Bronze medal in 100 m at South Zone Junior Athletics Championship; Gold Medal at U-20 Karnataka State Athletics Meet",
    image: require("../assets/athelete-2.png"),
    description:"Sprinter, Gold medal at 4x100m Relay at South Zone Junior Athletics Championship; Bronze medal in 100 m at South Zone Junior Athletics Championship; Gold Medal at U-20 Karnataka State Athletics Meet",
  },
  {
    name: "Keerthana S",
    // title: "Gold Medal in 4*100M Relay, 38th National Games at Uttarakhand",
    image: require("../assets/keerthana2.png"),
    description: "Achieved a Gold Medal in 4*100M Relay at the 38th National Games at Uttarakhand. Being honored by the GOVERNMENT OF KARNATAKA makes this achievement even more special.",
  },
  {
    name: "Alvas Kho-Kho Team",
    // title: "Sports: Kho-Kho, All-India Inter-University Gold Medal",
    image: require("../assets/athelete-3.png"),
    description:  "Sports: Kho-Kho, All-India Inter-University Gold Medal",
  },
  {
    name: "Siddu",
    // title: "Javelin, State Dussehra Cup Bronze Medal",
    image: require("../assets/Siddu2.png"),
        description: "state level dasara sports meet-2025, won silver medal",

  },
  {
    name: "Shradha",
    // title: "Sprinter, Gold Medal in 200m at U-23 Karnataka State Athletics Meet; Silver medal in 100m at U-23 Karnataka State Athletics Meet",
    image: require("../assets/athelete-4.png"),
    description: "Sprinter, Gold Medal in 200m at U-23 Karnataka State Athletics Meet; Silver medal in 100m at U-23 Karnataka State Athletics Meet",
  },
  {
    name: "Sanath",
    // title: "Sprinter, Bronze Medal in 200m at U-20 Karnataka State Athletics Meet",
    image: require("../assets/athelete-5.png"),
        description: "Sprinter, Bronze Medal in 200m at U-20 Karnataka State Athletics Meet",

  },
  {
    name: "Glanish",
    // title: "Badminton, Gold Medal at Karnataka Olympics",
    image: require("../assets/athelete-6.png"),
        description: "Badminton, Gold Medal at Karnataka Olympics",

  },
  {
    name: "Kshitij",
    // title: "Badminton, Bronze medal at U-19 Mixed Double State Championship Title ",
    image: require("../assets/athelete-7.png"),
        description: "Badminton, Bronze medal at U-19 Mixed Double State Championship Title ",

  },
  {
    name: "Prajitha",
    // title: "Marathoner, Silver medal at Kovalam Marathon, Trivandrum ; 4th Position in 12 hr run in Bangalore",
    image: require("../assets/athelete-8.png"),
        description: "Marathoner, Silver medal at Kovalam Marathon, Trivandrum ; 4th Position in 12 hr run in Bangalore",

  },
  {
    name: "Siddu",
    // title: "Javelin, State Dussehra Cup Bronze Medal",
    image: require("../assets/athelete-9.png"),
        description: "Javelin, State Dussehra Cup Bronze Medal",

  },
  {
    name: "Sareeka Shetty",
    // title: "Swimmer, Gold, State government emplyoees Association championship",
    image: require("../assets/athelete-10.png"),
        description: "Swimmer, Gold, State government emplyoees Association championship",

  },
  {
    name: "Somappa",
    // title: "Karate, State Dussehra Cup Silver Medal ",
    image: require("../assets/athelete-11.png"),
        description: "Karate, State Dussehra Cup Silver Medal ",

  },
  {
    name: "Keerthana",
    // title: "Sprinter, Gold Medal at 4x100m Relay at National Games 2025; U-23 State meet record & Gold medal at Karnataka State Athletics Meet ",
    image: require("../assets/Keerthana.png"),
        description: "Sprinter, Gold Medal at 4x100m Relay at National Games 2025; U-23 State meet record & Gold medal at Karnataka State Athletics Meet ",

  },
  {
    name: "Dr. Aparna Nayak",
    // title: "Marathoner, Silver Medal at Bhadra Trail run & Canara Marathon; Silver medal at Mixed relay at 24 Hr Stadium run at Bangalore",
    image: require("../assets/Aparna.png"),
        description: "Marathoner, Silver Medal at Bhadra Trail run & Canara Marathon; Silver medal at Mixed relay at 24 Hr Stadium run at Bangalore",

  },
];

// const technicalTeamData = [
//   {
//     name: "Pratham Naik",
//     title: "Embedded System Engineer",
//     image: require("../assets/Pratham.png"),
//     description:
//       "B.E. in Electronics & Communication.",
//   },
//     {
//     name: "Karthik Pattar",
//     title: "Jr. Embedded System Engineer",
//     image: require("../assets/Karthik.png"),
//     description:
//       "B.E. in Electronics & Communication.",
//   },
//   {
//     name: "Chethankumar",
//     title: "Software Engineer",
//     image: require("../assets/Ch.png"),
//     description:
//       "B.E. in Computer Science & Engineering.",
//   },
//   {
//     name: "Anmol D Poojari",
//     title: "Software Developer Intern",
//     image: require("../assets/Anmol.png"),
//     description:
//       "B.E. in Computer Science & Engineering.",
//   },
// ];

const SlidingCardSection = ({ heading, subheading, type }) => {
  const [expandedCard, setExpandedCard] = useState(null);
  const sliderRef = useRef(null);

  const toggleCard = (index) => {
    setExpandedCard(expandedCard === index ? null : index);
  };

  const settings = {
    dots: true,
    infinite: false,
    speed: 700,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 600,
        settings: { slidesToShow: 1 },
      },
    ],
  };

 const cardData =
  type === "athletes"
    ? athleteData
    : trainerData;

  return (
   <section
    className="sliding-section"
    id={
      type === "athletes"
        ? "athletes"
        : type === "technical"
        ? "technical-team"
        : "team"
     }
    >
      <div className="slider-header">
        <h2>
          Meet Our <span className="highlight-text">{heading}</span>
        </h2>
        {/* <div className="arrow-buttons">
          <button className="arrow-btn" onClick={() => sliderRef.current.slickPrev()}>
            ←
          </button>
          <button className="arrow-btn" onClick={() => sliderRef.current.slickNext()}>
            →</button>
        </div> */}
      </div>
      <p className="sub">{subheading}</p>

      <Slider {...settings} ref={sliderRef}>
        {cardData.map((card, idx) => (
          <div className="card-wrapper" key={idx}>
            <div className={`trainer-card ${type === "athletes" ? "athlete-card" : ""}`}>
              <img
  src={card.image}
  alt={
    type === "athletes"
      ? `${card.name}, Athlete at Aikyam Sports Science`
      : `${card.name}, ${card.title} at Aikyam Sports Science`
  }
/>
              <div className="card-info">
                <h4>{card.name}</h4>
                <p>{card.title}</p>

                {card.description && (
                  expandedCard === idx ? (
                    <>
                      <p className="card-description">{card.description}</p>
                      <button onClick={() => toggleCard(idx)}>Read Less ↑</button>
                    </>
                  ) : (
                    <button
  onClick={() => toggleCard(idx)}
  aria-expanded={expandedCard === idx}
  aria-label={`Read more about ${card.name}`}
>Read More →</button>
                  )
                )}
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default SlidingCardSection;